// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_STROLLER_REVIEWS_stroller = "%(stroller)s - Pou\u017e\u00edvate\u013esk\u00e9 recenzie a hodnotenia - Ko\u010d\u00edkop\u00e9dia";
export const STROLLER_ADD_REVIEW = "Pridaj hodnotenie";
export const STROLLER_SEO_GENERAL_DESC = "Ve\u013ek\u00e1 datab\u00e1za ko\u010d\u00edkov Modr\u00e9ho kon\u00edka";
